import Config from "../config";

export const getProvidersUrl = () => {
  const flowOrigin = localStorage.getItem("flowOrigin") || "alf";
  const serviceId = localStorage.getItem("serviceId");
  const callbackUrl = localStorage.getItem("callbackUrl");

  if (flowOrigin === "gsat") {
    return `${Config.GSAT_BASE_URL}/providers/${serviceId}/?url=${callbackUrl}`;
  }
  return `${Config.FE_BASE_URL}/${serviceId}?url=${callbackUrl}`;
};
